export default "/app-page/javascript/public/images/heavy-a7ef0225d5a95ddc.png"